import { render, staticRenderFns } from "./all_list.vue?vue&type=template&id=55938fd2&scoped=true&"
import script from "./all_list.vue?vue&type=script&lang=js&"
export * from "./all_list.vue?vue&type=script&lang=js&"
import style0 from "./all_list.vue?vue&type=style&index=0&id=55938fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55938fd2",
  null
  
)

export default component.exports